import script from "./OrderNumberGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderNumberGuide.vue?vue&type=script&setup=true&lang=js"

import "./OrderNumberGuide.vue?vue&type=style&index=0&id=52947a2c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52947a2c"]])

export default __exports__